import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';

interface IModalLegalProps {
  open: boolean;
  toggle: any;
}

export default function ModalRequirements(props: IModalLegalProps) {
  const { open = true, toggle } = props;

  return (
    <Modal modalClassName="format-new-modal" isOpen={open} size="lg" fade={false}>
      <div className="modal-header">
        <div className="close-modal-header w-100 d-flex text-align-left justify-content-between">
            <img
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_chevron.svg"
                alt=""
                onClick={toggle(false)}
            />
            <img 
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Action%20Group.svg"
                alt=""
                onClick={toggle(false)}
            />
        </div>
        <h4 className="modal-title px-20">Requisitos</h4>
      </div>
      <ModalBody className="px-16">
        <ul>
            <li>Asegurado, cónyuge o pareja deben ser mayores de 18 años.</li>
            <li>Edad máxima de ingreso: 59 años y 364 días.</li>
            <li>Edad máxima hasta la que puedes estar asegurado: 65 años y 364 días.</li>
            <li>Contar con Isapre o Fonasa.</li>
            <li>El asegurado debe completar DPS (Declaración Personal de Salud).</li>
            <li>Tope por evento de UF 50.</li>
            <li>Tiene deducible (monto fijo que debes pagar por el seguro) anual por grupo familiar.</li>
            <li>Este seguro te protegerá después de lo que te cubre tu Isapre o Fonasa.</li>
        </ul>
      </ModalBody>
    </Modal>
  );
}
